export default {"src":"/_next/static/media/breakdown.0a0de34f.svg","height":25,"width":20,"blurWidth":0,"blurHeight":0};